module.exports = __webpack_public_path__ + "static/media/lalashan1.c62b60af.webp";